import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import QrCodePage from "../pages/QrCodePage";
import QRCreation from "../pages/QRCreationPage";
import Plans from "../pages/Plans";
import EditQrCodePage from "../pages/EditQrCodePage";
import PaymentPage from "../pages/PaymentPage";
import Analytics from "../pages/Analytics";
import ScanLimit from "../pages/ScanLimit";
import SignIn from "../components/auth/SignIn";
import SignUp from "../components/auth/SignUp";
import ResetPassword from "../components/auth/ResetPassword";
import PasswordVerification from "../pages/PasswordVerification";
import ProtectedRoute from "./ProtectedRoute";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";
import HelpCenter from "../pages/HelpCenter";
import HelpCategory from "../pages/HelpCategory";
import HelpArticle from "../pages/HelpArticle";

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/verify/:urlId" element={<PasswordVerification />} />
      <Route path="/help" element={<HelpCenter />} />
      <Route path="/help/:category" element={<HelpCategory />} />
      <Route path="/help/:category/:article" element={<HelpArticle />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/qrcodes"
        element={
          <ProtectedRoute>
            <QrCodePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/qrcodes/create"
        element={
          <ProtectedRoute>
            <QRCreation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/qrcodes/edit/:id"
        element={
          <ProtectedRoute>
            <EditQrCodePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/plans/:id?"
        element={
          <ProtectedRoute>
            <Plans />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/payment/:id"
        element={
          <ProtectedRoute>
            <PaymentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/analytics"
        element={
          <ProtectedRoute>
            <Analytics />
          </ProtectedRoute>
        }
      />
      <Route path="/scanLimit" element={<ScanLimit />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
    </Routes>
  );
};

export default Routers;
